// extracted by mini-css-extract-plugin
export default {"container":"CardLayout_container__TF3sF","header":"CardLayout_header__yi3ui","title":"CardLayout_title__+1xOH","content":"CardLayout_content__P2mMj"};